export default "__VITE_ASSET__C8iQtYQR__"